
import { Component } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import ComEmpty from '@/components/com-empty.vue';
// @ts-ignore
import TrackeData from '@/utils/trackData';
import { Spin } from 'ant-design-vue';
import ClasstypeList from '../../components/classtype-list.vue';
import IndexFilter from './index-filter.vue';
import Guide from '../../js/guide';

interface SelectParams {
  subjectProId: number;
  gradeId: number;
  period: number;
  schemeId: number;
  bookVersionId: number;
  examId: number;
  year: number;
  userId: number;
  subjectId: number;
}

interface ManageObject {
  username: string;
  telephone: number;
}

const user = namespace('user');
@Component({
  components: {
    IndexFilter,
    ClasstypeList,
    ComEmpty,
    ASpin: Spin,
  },
})
export default class Index extends Guide {
[x: string]: any;

  @user.State('userInfo') userInfo: any;

  private selectedParams: SelectParams = {
    subjectProId: 0,
    gradeId: 0,
    period: 0,
    schemeId: 0,
    bookVersionId: 0,
    examId: 0,
    year: 0,
    userId: 0,
    subjectId: 0,
  };

  private classTypeList: any = []

  // 加载组件状态
  private spinning: boolean = false

  // 班级数
  private allSize: number = 0;

  // 当前账号权限是否是管理员或教务
  private admin: boolean = false;

  // 没有课程时候tip显示状态
  private showTip: boolean = false;

  private manageList: ManageObject[] = [];

  get currentRoleIsManage(): boolean {
    const { roles } = this.userInfo;
    // 教务、管理员、超管
    return (
      roles.indexOf('manage') !== -1
      || roles.indexOf('super_manager') !== -1
      || roles.indexOf('jiaowu') !== -1
    );
  }

  private handleSelectedCondition(conditionParams: SelectParams) {
    this.selectedParams = conditionParams;
    this.getClassTypeList();
  }

  // 获取班型列表
  private async getClassTypeList() {
    this.spinning = true;
    const result = await this.$service.bk.getClassTypeList(this.selectedParams);
    this.spinning = false;
    this.classTypeList = result;
    this.classTypeList.forEach((item: any) => {
      if (item.labels) {
        item.labels.sort();
      }
    });
    this.$nextTick(() => {
      this.$bus.$emit('showGuide', 'allCourse');
    });
  }

  // 没有课程时候 hover 显示提示
  private handleShowTip(show: boolean): void {
    this.showTip = show;
  }

  // 获取管理员列表
  private getAdminList() {
    this.$service.common.getAdminList().then((data: []) => {
      this.manageList = data.splice(0, 3);
    });
  }

  // 去设置
  private handleGoSetUp() {
    this.$utils.sendAction('index', 'index', 'id-16');
    window.open('//ghostrider.aixuexi.com/education.html#/setting/textbook', '_blank');
  }

  // 刷新
  private handleRefresh() {
    this.$utils.sendAction('index', 'index', 'id-15');
    this.getClassTypeList();
  }

  // private mounted() {
  //   // 全部课程是否有返回按钮
  //   this.$service.bk.getMyClassAndType({
  //     subjectId: 0,
  //     gradeId: 0,
  //     createdClass: 0,
  //     typesId: 0,
  //     period: 0,
  //   }).then((res: any) => {
  //     this.allSize = res.allSize;
  //   });
  // }
  mounted() {
    if (!this.currentRoleIsManage) {
      this.getAdminList();
    }
    // 延迟检查 this.$track 是否有值 埋点
    const checkTrack = setInterval(() => {
      if (this.$track) {
        this.$track.sendPageLog(TrackeData.PRELESSONSLIST_PAGE_SHOW, {});
        clearInterval(checkTrack);
      }
    }, 100); // 每100毫秒检查一次
  }
}
